import { AbstractClient, CompositionClient } from "@/app/client";
import { UUID } from "crypto";
import * as types from "@/app/types";

export default class APIConfirmEmail extends CompositionClient {
  constructor(client: AbstractClient) {
    super(client);
  }

  postToken = async (token: string): Promise<any> => {
    let res = await this._fetch({
      url: `/users/confirm-email/${token}`,
      method: "POST",
    });
    if (res.headers.get("Content-Type") === "application/json")
      return res.json();
    throw new Error("Bad content type");
  };
}
